import { render, staticRenderFns } from "./form-component-select.vue?vue&type=template&id=ca76c0aa&scoped=true"
import script from "./form-component-select.vue?vue&type=script&lang=ts"
export * from "./form-component-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca76c0aa",
  null
  
)

export default component.exports